import { SYSTEM_ERROR } from "../../src/config/CONSTANT";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllStaff = () => {
  return new Promise((resolve, reject) => {
    try {
   
   
          axios
            .get(
              `${BaseUrl}/api/staff`,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              axios.defaults.headers.common["X-CSRF-TOKEN"] = res;
              resolve(res.data);
            })   .catch((error) => {
              if (error.res && error.res.status === 500) {
                sweetalert(error.res.msg, {
                  className: "alert-div",
                  button: {
                    text: "تم",
                  },
                });
              }
            });
        
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Function to fetch the details of the user based on userId.
 * @param {string} userid of the user.
 * early dev example passing Skeleton(static object) as API response.
 */
